var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "RedeemCodeBundleList",
      "extra-items": _vm.isShow ? [{
        text: _vm.form.name
      }] : _vm.isEdit ? [{
        text: _vm.form.name,
        to: 'RedeemCodeBundleDetail',
        params: _vm.$route.params.redeemCodeBundleId
      }, '編輯優惠券'] : ['新增優惠券']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路",
      "label-for": "merchant"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants || _vm.isShow
    },
    model: {
      value: _vm.form.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v);
      },
      expression: "form.merchant_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.merchant_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabled_branch_select
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selected_branch,
      callback: function callback($$v) {
        _vm.selected_branch = $$v;
      },
      expression: "selected_branch"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動事件",
      "label-for": "event"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.eventOptions,
      "disabled": _vm.isFetchEvent || _vm.isShow
    },
    model: {
      value: _vm.form.event_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "event_id", $$v);
      },
      expression: "form.event_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "獎項名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "state": _vm.v$.form.name.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "獎項描述",
      "label-for": "description"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "description",
      "type": "text",
      "disabled": _vm.isShow,
      "row": "6"
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "img_url"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 圖片 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": "0.75rem"
          }
        }, [_vm._v(" 寬 x 高：1400px x 700px ")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticClass: "image-selector"
        }, [_vm.image || _vm.form.img_url ? _c('div', {
          staticClass: "image"
        }, [_c('img', {
          staticClass: "img-fluid",
          attrs: {
            "src": _vm.image != null ? _vm.image : _vm.form.img_url
          }
        }), !_vm.isShow ? _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.image = _vm.form.img_url = null;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times m-0"
        })]) : _vm._e()]) : _c('div', {
          staticClass: "selector"
        }, [_c('ImageSelector', {
          staticClass: "\n                      border\n                      h-100\n                      d-flex\n                      justify-content-center\n                      align-items-center\n                    ",
          attrs: {
            "aspectRatio": 2 / 1
          },
          on: {
            "input": function input($event) {
              return _vm.selectImage('image', $event);
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref) {
              var openFileSelector = _ref.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                attrs: {
                  "disabled": !_vm.canClick
                },
                on: {
                  "click": openFileSelector
                }
              }, [_c('i', {
                staticClass: "fa fa-plus"
              }), _vm._v(" 圖片 ")])];
            }
          }, {
            key: "content",
            fn: function fn() {
              return [_c('small', {
                staticClass: "text-center mb-2"
              }, [_vm._v(" 建議尺寸 寬1400px 、 高 700px ")])];
            },
            proxy: true
          }])
        })], 1)])];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "thumb_img_url"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 縮圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": "0.75rem"
          }
        }, [_vm._v(" 寬 x 高：700px x 700px ")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          staticClass: "image-selector thumbnail"
        }, [_vm.thumbImage || _vm.form.thumb_img_url ? _c('div', {
          staticClass: "image"
        }, [_c('img', {
          staticClass: "img-fluid",
          attrs: {
            "src": _vm.thumbImage != null ? _vm.thumbImage : _vm.form.thumb_img_url
          }
        }), !_vm.isShow ? _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.thumbImage = _vm.form.thumb_img_url = null;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times m-0"
        })]) : _vm._e()]) : _c('div', {
          staticClass: "selector"
        }, [_c('ImageSelector', {
          staticClass: "\n                      border\n                      h-100\n                      d-flex\n                      justify-content-center\n                      align-items-center\n                    ",
          attrs: {
            "aspectRatio": 1 / 1
          },
          on: {
            "input": function input($event) {
              return _vm.selectImage('thumbImage', $event);
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref2) {
              var openFileSelector = _ref2.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                attrs: {
                  "disabled": !_vm.canClick
                },
                on: {
                  "click": openFileSelector
                }
              }, [_c('i', {
                staticClass: "fa fa-plus"
              }), _vm._v(" 圖片 ")])];
            }
          }, {
            key: "content",
            fn: function fn() {
              return [_c('small', {
                staticClass: "text-center mb-2"
              }, [_vm._v(" 建議尺寸 寬700px 、 高 700px ")])];
            },
            proxy: true
          }])
        })], 1)])];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發布狀態",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.status.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "優惠券種類",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.targetSourceOptions
    },
    model: {
      value: _vm.form.target_source,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "target_source", $$v);
      },
      expression: "form.target_source"
    }
  })], 1), _vm.showTargetDiscount ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "折扣方式"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-wrap"
  }, [_c('div', {
    staticClass: "position-relative",
    staticStyle: {
      "flex": "0 0 15%"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.discountTypeOptions,
      "state": _vm.v$.form.target_discount_type.$error ? false : null
    },
    model: {
      value: _vm.form.target_discount_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "target_discount_type", $$v);
      },
      expression: "form.target_discount_type"
    }
  }), _c('b-form-invalid-feedback', {
    staticClass: "position-absolute",
    staticStyle: {
      "top": "100%",
      "left": "0"
    },
    attrs: {
      "state": !_vm.v$.form.target_discount_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "position-relative",
    staticStyle: {
      "flex": "0 0 15%",
      "margin-left": "20px"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.target_discount_type === _vm.consts.DISCOUNT_TYPE.PERCENTAGE || _vm.form.target_discount_type === _vm.consts.DISCOUNT_TYPE.AMOUNT,
      expression: "form.target_discount_type === consts.DISCOUNT_TYPE.PERCENTAGE ||\n                        form.target_discount_type === consts.DISCOUNT_TYPE.AMOUNT"
    }],
    attrs: {
      "id": "discount-input",
      "type": "text",
      "state": _vm.v$.form.target_discount_input.$error ? false : null
    },
    on: {
      "input": _vm.onDiscountInput,
      "blur": _vm.onDiscountBlur
    },
    model: {
      value: _vm.form.target_discount_input,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "target_discount_input", _vm._n($$v));
      },
      expression: "form.target_discount_input"
    }
  }), _c('b-form-invalid-feedback', {
    staticClass: "position-absolute",
    staticStyle: {
      "top": "100%",
      "left": "0"
    },
    attrs: {
      "state": !_vm.v$.form.target_discount_input.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.target_discount_type === _vm.consts.DISCOUNT_TYPE.PERCENTAGE,
      expression: "form.target_discount_type === consts.DISCOUNT_TYPE.PERCENTAGE"
    }],
    staticClass: "ml-2",
    attrs: {
      "id": "percentage"
    }
  }, [_vm._v(" % "), _c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.target_discount_type === _vm.consts.DISCOUNT_TYPE.AMOUNT,
      expression: "form.target_discount_type === consts.DISCOUNT_TYPE.AMOUNT"
    }],
    staticClass: "ml-2",
    attrs: {
      "id": "amount"
    }
  }, [_vm._v(" 元 "), _c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })])]), _c('b-tooltip', {
    attrs: {
      "target": "percentage",
      "placement": "bottom"
    }
  }, [_vm._v(" 若打 85折，請輸入 85 ")]), _c('b-tooltip', {
    attrs: {
      "target": "amount",
      "placement": "bottom"
    }
  }, [_vm._v(" 若折扣 125 元，請輸入 125 ")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "獎項類型",
      "label-for": "type"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.redeemCodeBundleTypes,
      "disabled": _vm.isShow || _vm.isEdit,
      "state": _vm.v$.form.type.$error ? false : null
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "序號",
      "label-for": "type"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.redeemCodeTypes,
      "disabled": _vm.isShow || _vm.isLinePointType || _vm.isEdit
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-radio', {
          attrs: {
            "value": _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE
          },
          model: {
            value: _vm.form.redeemcode_type,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "redeemcode_type", $$v);
            },
            expression: "form.redeemcode_type"
          }
        }, [_vm._v(" 上傳序號包 "), _vm.form.redeemcode_type === _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE && !_vm.isShow ? [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-upload",
            modifiers: {
              "modal-upload": true
            }
          }],
          staticClass: "mx-2"
        }, [_vm._v(" 上傳 ")])] : _vm._e()], 2)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.redeemcode_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "redeemcode_type", $$v);
      },
      expression: "form.redeemcode_type"
    }
  })], 1), _vm.form.redeemcode_type === _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE || _vm.form.redeemcode_type === _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.FIXED || _vm.form.redeemcode_type === _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.RANDOM ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "不顯示文字序號"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.is_hide_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_hide_code", $$v);
      },
      expression: "form.is_hide_code"
    }
  })], 1) : _vm._e(), _vm.form.redeemcode_type === 2 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "固定序號",
      "label-for": "static_redeem_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "static_redeem_code",
      "type": "text",
      "disabled": _vm.isShow,
      "state": _vm.v$.form.static_redeem_code.$dirty && _vm.v$.form.static_redeem_code.$invalid ? false : null
    },
    on: {
      "blur": function blur($event) {
        return _vm.v$.form.static_redeem_code.$touch();
      }
    },
    model: {
      value: _vm.form.static_redeem_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "static_redeem_code", $$v);
      },
      expression: "form.static_redeem_code"
    }
  }), _vm.v$.form.static_redeem_code.$dirty && _vm.v$.form.static_redeem_code.$invalid ? _c('b-form-invalid-feedback', [_vm.v$.form.static_redeem_code.requiredIf.$invalid ? _c('span', [_vm._v("此欄位為必填")]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm.form.redeemcode_type == 2 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "序號張數上限",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "不填寫表示無限",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.static_redeem_code_ceil_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "static_redeem_code_ceil_limit", $$v);
      },
      expression: "form.static_redeem_code_ceil_limit"
    }
  })], 1) : _vm._e(), _vm.form.redeemcode_type === 3 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "隨機序號長度",
      "label-for": "random_redeem_code_length"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "random_redeem_code_length",
      "type": "number",
      "disabled": _vm.isShow || _vm.isEdit,
      "state": _vm.v$.form.random_redeem_code_length.$dirty && _vm.v$.form.random_redeem_code_length.$invalid ? false : null
    },
    on: {
      "blur": function blur($event) {
        return _vm.v$.form.random_redeem_code_length.$touch();
      }
    },
    model: {
      value: _vm.form.random_redeem_code_length,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "random_redeem_code_length", $$v);
      },
      expression: "form.random_redeem_code_length"
    }
  }), _vm.v$.form.random_redeem_code_length.$dirty && _vm.v$.form.random_redeem_code_length.$invalid ? _c('b-form-invalid-feedback', [_vm.v$.form.random_redeem_code_length.requiredIf.$invalid ? _c('span', [_vm._v("此欄位為必填")]) : _vm.v$.form.random_redeem_code_length.minValue.$invalid ? _c('span', [_vm._v("最小值需為 1")]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm.form.redeemcode_type == 3 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "序號張數上限",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "不填寫表示無限",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.random_redeem_code_ceil_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "random_redeem_code_ceil_limit", $$v);
      },
      expression: "form.random_redeem_code_ceil_limit"
    }
  })], 1) : _vm._e(), _vm.form.redeemcode_type == 0 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "數量張數上限",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "不填寫表示無限",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.none_redeem_code_ceil_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "none_redeem_code_ceil_limit", $$v);
      },
      expression: "form.none_redeem_code_ceil_limit"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "領券超過總數量上限時的提示文字",
      "label-for": "custom-limit-message"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "custom-limit-message",
      "type": "text",
      "placeholder": "不填寫時顯示「優惠券已發完」",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.custom_limit_message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "custom_limit_message", $$v);
      },
      expression: "form.custom_limit_message"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示條碼",
      "label-for": "is_show_barcode"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "is_show_button",
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.isShow || _vm.form.redeemcode_type == _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.NONE || _vm.isLinePointType
    },
    model: {
      value: _vm.form.is_show_barcode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_barcode", $$v);
      },
      expression: "form.is_show_barcode"
    }
  })], 1), _vm.form.is_show_barcode ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "條碼類型",
      "label-for": "barcode_type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.barcodeTypes,
      "disabled": ""
    },
    model: {
      value: _vm.form.barcode_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "barcode_type", $$v);
      },
      expression: "form.barcode_type"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "領取方式"
    }
  }, [_c('div', {
    staticClass: "take-type-categories"
  }, _vm._l(_vm.takeTypeCategories, function (category) {
    return _c('div', {
      key: category.id,
      staticClass: "take-type-category"
    }, [_c('h6', {
      staticClass: "category-title"
    }, [_vm._v(_vm._s(category.title))]), _c('div', {
      staticClass: "category-options-row"
    }, [_vm._l(category.options, function (option) {
      return [_c('b-form-radio', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.html.hover.bottom",
          value: {
            customClass: 'text-left'
          },
          expression: "{ customClass: 'text-left' }",
          modifiers: {
            "html": true,
            "hover": true,
            "bottom": true
          }
        }],
        key: option.value,
        attrs: {
          "value": option.value,
          "disabled": _vm.getOptionDisabled(option),
          "state": _vm.v$.form.take_type.$error ? false : null,
          "title": option.tooltip
        },
        model: {
          value: _vm.form.take_type,
          callback: function callback($$v) {
            _vm.$set(_vm.form, "take_type", $$v);
          },
          expression: "form.take_type"
        }
      }, [_vm._v(" " + _vm._s(option.text) + " "), option.value === _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT ? [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.form.point_need,
          expression: "form.point_need"
        }],
        staticClass: "reclaim-input mx-2",
        attrs: {
          "type": "number",
          "min": "0",
          "disabled": _vm.isShow || _vm.form.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT,
          "placeholder": "點數"
        },
        domProps: {
          "value": _vm.form.point_need
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.form, "point_need", $event.target.value);
          }
        }
      }), _vm._v(" 點 ")] : _vm._e(), _c('span', {
        staticClass: "mdi mdi-help-circle-outline"
      })], 2)];
    })], 2)]);
  }), 0), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.take_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _vm.form.take_type === _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT ? _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.point_need.$error
    }
  }, [_vm._v(" 兌換點數為必填，且必須大於等於 0 ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "可否重複領券"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "state": _vm.v$.form.take_type.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.reclaim_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reclaim_type", $$v);
      },
      expression: "form.reclaim_type"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": _vm.consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_UNLIMITED
    }
  }, [_vm._v(" 不限次數 ")]), _c('b-form-radio', {
    attrs: {
      "value": _vm.consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_LIMITED
    }
  }, [_vm._v(" 每人限領 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.reclaim_times,
      expression: "form.reclaim_times"
    }],
    staticClass: "reclaim-input",
    attrs: {
      "type": "number",
      "min": "1",
      "disabled": _vm.form.reclaim_type != _vm.consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_LIMITED
    },
    domProps: {
      "value": _vm.form.reclaim_times
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reclaim_times", $event.target.value);
      }
    }
  }), _vm._v(" 次 ")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.reclaim_type.$error
    }
  }, [_vm._v(" 此欄位必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.reclaim_times.$error
    }
  }, [_vm._v(" 次數必須大於 0 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "領券次數超過上限時提示文字",
      "label-for": "reclaim-message"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "reclaim-message",
      "disabled": _vm.isShow,
      "placeholder": "不填寫時顯示「領取超過限額次數」"
    },
    model: {
      value: _vm.form.reclaim_message,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reclaim_message", $$v);
      },
      expression: "form.reclaim_message"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "領取期限"
    }
  }, [_c('div', {
    staticClass: "\n                d-flex\n                flex-column flex-xl-row\n                align-items-start align-items-xl-center\n              "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isShow,
      "disabledDates": _vm.disabledDates,
      "clear-button": ""
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isShow,
      "disabledDates": _vm.disabledDates,
      "clear-button": ""
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用方式"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.usageTypes,
      "state": _vm.v$.form.usage_type.$error ? false : null,
      "disabled": _vm.isShow || _vm.form.take_type == _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.SYSTEM_ASSIGN
    },
    model: {
      value: _vm.form.usage_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "usage_type", $$v);
      },
      expression: "form.usage_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.usage_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用期限"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.datelineTypes,
      "state": _vm.v$.form.dateline_type.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.dateline_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dateline_type", $$v);
      },
      expression: "form.dateline_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.dateline_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _vm.form.dateline_type == _vm.consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.SAME_AS_TAKE_TIME ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('div', {
    staticClass: "\n                d-flex\n                flex-column flex-xl-row\n                align-items-start align-items-xl-center\n              "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": true
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": true
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  })], 1)]) : _vm._e(), _vm.form.dateline_type == _vm.consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.CUSTOM ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('div', {
    staticClass: "\n                d-flex\n                flex-column flex-xl-row\n                align-items-start align-items-xl-center\n              "
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isShow,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.used_start_at,
      callback: function callback($$v) {
        _vm.used_start_at = $$v;
      },
      expression: "used_start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isShow,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.used_end_at,
      callback: function callback($$v) {
        _vm.used_end_at = $$v;
      },
      expression: "used_end_at"
    }
  })], 1)]) : _vm._e(), _vm.form.dateline_type == _vm.consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.BY_TAKE_DATE ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          attrs: {
            "id": "start-day-tooltip"
          }
        }, [_vm._v(" 領取後幾日可使用 "), _c('span', {
          staticClass: "mdi mdi-help-circle-outline ml-1 align-middle"
        })])];
      },
      proxy: true
    }], null, false, 1958992236)
  }, [_c('b-tooltip', {
    attrs: {
      "target": "start-day-tooltip",
      "placement": "right"
    }
  }, [_vm._v(" 0為領取後立即可使用 ")]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "number",
      "placeholder": "0為領取後立即可使用",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.start_days_after_take,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "start_days_after_take", $$v);
      },
      expression: "form.start_days_after_take"
    }
  })], 1) : _vm._e(), _vm.form.dateline_type == _vm.consts.REDEEM_CODE_BUNDLE_DATELINE_TYPES.BY_TAKE_DATE ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          attrs: {
            "id": "start-day-tooltip-1"
          }
        }, [_vm._v(" 領取後幾日內有效 "), _c('span', {
          staticClass: "mdi mdi-help-circle-outline ml-1 align-middle"
        })])];
      },
      proxy: true
    }], null, false, 1277955982)
  }, [_c('b-tooltip', {
    attrs: {
      "target": "start-day-tooltip-1",
      "placement": "right"
    }
  }, [_vm._v(" 0 為當日需使用完畢 ")]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "number",
      "placeholder": "0為領取後當日需使用完畢",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.end_days_after_take,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "end_days_after_take", $$v);
      },
      expression: "form.end_days_after_take"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "核銷設定"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.confirmTypes,
      "state": _vm.v$.form.confirm_type.$error ? false : null,
      "disabled": _vm.isShow || _vm.isLinePointType
    },
    model: {
      value: _vm.form.confirm_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "confirm_type", $$v);
      },
      expression: "form.confirm_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.confirm_type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示獎項按鈕",
      "label-for": "is_show_button"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "is_show_button",
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.isShow || _vm.isLinePointType
    },
    model: {
      value: _vm.form.is_show_button,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_button", $$v);
      },
      expression: "form.is_show_button"
    }
  })], 1), _vm.form.is_show_button ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "按鈕文字",
      "label-for": "button_text"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "button_text",
      "type": "text",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "button_text", $$v);
      },
      expression: "form.button_text"
    }
  })], 1) : _vm._e(), _vm.form.is_show_button && !_vm.isLinePointType ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "按鈕連結",
      "label-for": "button_url"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "button_url",
      "type": "text",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.form.button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "button_url", $$v);
      },
      expression: "form.button_url"
    }
  })], 1) : _vm._e(), _vm.form.is_show_button ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否以外部瀏覽器開啟",
      "label-for": "button_url_external"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "name": "button_url_external",
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.isShow || _vm.isLinePointType
    },
    model: {
      value: _vm.form.button_url_external,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "button_url_external", $$v);
      },
      expression: "form.button_url_external"
    }
  })], 1) : _vm._e()], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center mb-6 preserve-spacing-for-datetime-picker"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.isShow ? "返回" : "取消"))]), !_vm.isShow ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "上傳優惠券"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var cancel = _ref3.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": _vm.resetFile
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 確認 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳帳號 Excel 檔案")]), _c('div', {
    staticClass: "my-3"
  }, [_vm._v("已選擇檔案 : " + _vm._s(_vm.file ? _vm.file.name : ""))]), _c('b-form-file', {
    staticClass: "mb-3",
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.file,
      callback: function callback($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  }), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/event_redeem_code_list.xlsx",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案 ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }